module.exports = __webpack_public_path__ + "static/vertical1-cb5554ad13f8b7765e0a6ef40905b1fe.jpg";